var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgiBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: "auto",
      width: 36
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0L33.5 9V27L18 36L2.5 27V9L18 0ZM17.9996 2L31.7774 10V26L17.9996 34L4.22185 26V10L17.9996 2ZM18.0032 4L30.0587 11V25L18.0032 32L5.94761 25V11L18.0032 4ZM16.7433 8L22.6396 10.8385V24.3756L16.7433 27.2141L14.5631 25.8478V9.36629L16.7433 8ZM16.4312 8.98201L15.6392 9.47836L16.4312 9.78162V8.98201ZM16.4312 10.4952L15.2295 10.0351V25.1789L16.4312 24.7184V10.4952ZM17.0976 24.4631V10.7504L20.0755 11.8906V23.322L17.0976 24.4631ZM16.4312 25.4321L15.639 25.7356L16.4312 26.2321V25.4321ZM17.0976 26.3039V25.1767L20.4179 23.9044L21.4125 24.2267L17.0976 26.3039ZM21.9732 23.708L20.7419 23.3089V11.9038L21.9732 11.5058V23.708ZM21.4117 10.9869L20.418 11.3081L17.0976 10.0368V8.91017L21.4117 10.9869Z",
    fill: "#7FFAE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgiBlue);
export default __webpack_public_path__ + "static/media/agi-blue.251d77c18d3973637870653e570e4787.svg";
export { ForwardRef as ReactComponent };